function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "1.-Rollover-Call-Dashboard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "1.2.-Rollover-Call-Dashboard",
  transform: "translate(-64.000000, -280.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(64.000000, 244.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "event_black_24dp",
  transform: "translate(0.000000, 36.000000)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "0 0 16 0 16 16 0 16"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.6666667,2.66666667 L12,2.66666667 L12,1.33333333 L10.6666667,1.33333333 L10.6666667,2.66666667 L5.33333333,2.66666667 L5.33333333,1.33333333 L4,1.33333333 L4,2.66666667 L3.33333333,2.66666667 C2.59333333,2.66666667 2.00666667,3.26666667 2.00666667,4 L2,13.3333333 C2,14.0666667 2.59333333,14.6666667 3.33333333,14.6666667 L12.6666667,14.6666667 C13.4,14.6666667 14,14.0666667 14,13.3333333 L14,4 C14,3.26666667 13.4,2.66666667 12.6666667,2.66666667 Z M12.6666667,13.3333333 L3.33333333,13.3333333 L3.33333333,6.66666667 L12.6666667,6.66666667 L12.6666667,13.3333333 Z M12.6666667,5.33333333 L3.33333333,5.33333333 L3.33333333,4 L12.6666667,4 L12.6666667,5.33333333 Z M8,8.66666667 L11.3333333,8.66666667 L11.3333333,12 L8,12 L8,8.66666667 Z",
  id: "Shape",
  fill: "#0AA6A8",
  fillRule: "nonzero"
})))));

function SvgEventBlack24Dp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5A16739D-5C26-4FBA-8E1E-334B9040A713@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventBlack24Dp);
export default __webpack_public_path__ + "static/media/event_black_24dp.817433ad.svg";
export { ForwardRef as ReactComponent };